import { Injectable } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";

@Injectable()
export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private baseService: BaseService
  ) {
    this.angularFireMessaging.messages.subscribe(
      (_messaging: AngularFireMessaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    );
  }
  requestPermission(): Observable<string> {
    return this.angularFireMessaging.requestToken.pipe(
      tap((token) => {
        const url = `${environment.apiURL}/pushClient`;
        this.receiveMessage();
      })
    );
  }
  sendToServer(token: string, phoneNo: number) {
    let pushcred = {
      client: "patient_android",
      registration_id: token,
      phoneno: phoneNo,
    };
    const url = `${environment.apiURL}/pushclient`;
    return this.baseService.post(url, pushcred);
  }
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload) => {
      this.currentMessage.next(payload);
    });
  }
}
